import { render, staticRenderFns } from "./FilesView.vue?vue&type=template&id=6744370c&"
import script from "./FilesView.vue?vue&type=script&lang=ts&"
export * from "./FilesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6744370c')) {
      api.createRecord('6744370c', component.options)
    } else {
      api.reload('6744370c', component.options)
    }
    module.hot.accept("./FilesView.vue?vue&type=template&id=6744370c&", function () {
      api.rerender('6744370c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/files/FilesView.vue"
export default component.exports